import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "completedMoves"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["href"];
const _hoisted_4 = { class: "moveMeta" };
import { onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useMoves } from '@/composables/useMoves';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CompletedMovesPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getCompletedMoves } = useMoves();
        function dateToString(dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${day}/${month}/${year}`;
        }
        function onLoad() {
            getCustomer();
            getCompletedMoves((res) => {
                state.completedMoves = res.sort((a, b) => new Date(b.actioned).getTime() - new Date(a.actioned).getTime());
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(state).customer)
                    ? (_openBlock(), _createBlock(HeaderBlock, {
                        key: 0,
                        title: "Completed moves",
                        bgcolor: "white"
                    }))
                    : _createCommentVNode("", true),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).completedMoves
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).completedMoves)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).completedMoves, (m) => {
                                        return (_openBlock(), _createBlock(_component_v_row, {
                                            class: "moveRow",
                                            key: m.id
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                    cols: "1",
                                                    class: "iconCol"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("img", {
                                                            class: "moveIcon",
                                                            src: m.move.backgroundImage
                                                        }, null, 8, _hoisted_2)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("a", {
                                                            href: '/#/Moves/' + m.id
                                                        }, [
                                                            _createElementVNode("h2", null, _toDisplayString(m.title), 1),
                                                            _createElementVNode("p", null, _toDisplayString(m.description), 1),
                                                            _createElementVNode("div", _hoisted_4, [
                                                                _createTextVNode(_toDisplayString((m.actioned ? 'Completed ' + (m.actionedCount > 0 ? m.actionedCount + ' time(s)' : '') : 'Ignore for now')) + " ", 1),
                                                                _createElementVNode("span", null, _toDisplayString(dateToString(m.actioned)), 1)
                                                            ])
                                                        ], 8, _hoisted_3)
                                                    ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                            _: 2
                                        }, 1024));
                                    }), 128))
                                ]),
                                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "moveAd" }, [
                                    _createElementVNode("h1", null, "There's a Move for that"),
                                    _createElementVNode("p", null, "We want to hear what moves matter to you. Email us at help@moneyguided.com with any ideas!")
                                ], -1))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
